<template>
    <div class="registration page">
        <div class="container">
            <form @submit.prevent="register">
            <div class="row">
                <div class="col-12">
                    <h2 class="ktdarkchoc mediaHideOnDesctop">Lets’ get started</h2>
                    <div class="descktopMediaBox">
                        <div class="h1">
                            Hi! Let’s setup your account
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="First Name*"
                            required
                            v-model="form['base-first_name']"
                        >
                    </div>
                    <div class="form-group">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Last Name*"
                            required
                            v-model="form['base-last_name']"
                        >
                    </div>
                    <div class="form-group">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Username"
                            v-model="form['base-user_name']"
                        >
                    </div>
                    <div class="form-group">
                        <input
                            type="email"
                            id="email"
                            class="form-control"
                            placeholder="Email*"
                            required
                            v-model="form['base-email']"
                        >
                    </div>
                    <div class="form-group position-relative">
                        <VuePhoneNumberInput :required="true" @update="onUpdatePhone" v-model="form['base-phone']"/>
                    </div>
                    <div class="form-group">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Address"
                            v-model="form['base-address']"
                        >
                    </div>
                    <div class="form-group">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Apartment #, Floor"
                            v-model="form['base-address2']"
                        >
                    </div>
                    <div class="form-group">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="City"
                            v-model="form['base-city']"
                        >
                    </div>
                    <div class="form-group two">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Province"
                            v-model="form['base-state']"
                        >
                        <input
                            type="text"
                            id=""
                            class="form-control"
                            placeholder="Postal Code"
                            v-model="form['base-zipcode']"
                        >
                    </div>
                    <div class="form-group position-relative">
                        <md-field>
                            <md-input minlength="4"  required v-model="form['password']" type="password" placeholder="Password*"></md-input>
                        </md-field>
                        <div class="caption">Password must contain 4-10 characters, with no spaces.</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group position-relative">
                        <md-field>
                            <md-datepicker  @md-opened="$refs.mkDatePicker.$el.querySelector('input').blur()" ref="mkDatePicker" v-model="form['base-birthday']" md-immediately ><label>Birthday (Optional)</label></md-datepicker>
                        </md-field>
                        <div class="caption">So we can surprise you with a birthday treat.</div>
                    </div>
                </div>
                <div class="col-12 form-group mt-3 mb-4">
                    <div class="custom-control custom-checkbox">
                        <input
                            type="checkbox"
                            value="1"
                            class="custom-control-input"
                            id="customSwitch2"
                            @change="form.notifications = !form.notifications"
                        />
                        <label class="custom-control-label regText normal" for="customSwitch2">Yes, I want to receive promotional emails</label>
                    </div>
                    <div class="custom-control custom-checkbox ">
                        <input
                            type="checkbox"
                            value="1"
                            class="custom-control-input"
                            id="customSwitch1"
                            :checked="form.terms"
                            @change="form.terms = !form.terms"
                            required
                        />
                        <label class="custom-control-label regText normal" for="customSwitch1">Yes, I agree to <a @click="confirmTerms">terms and conditions*</a></label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <input type="submit" class="zbg join" value="Join now">
                </div>
            </div>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import forms_invalid_scroll from "../../mixins/forms_invalid_scroll";
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';

    export default {
        name: 'Registration',
        mixins: [forms_invalid_scroll],
        data(){
            return{
                passwordType: "password",
                passwordIcon: "show",
                phonePayload: null
            }
        },
        created() {
            this.$store.commit("shared/setTopBar", {title: "Join Kettleman’s", showLocationSearch: true});
        },
        methods:{
            confirmTerms() {
                axios.get(`/unauth/groups/149/settings`).then(res => {
                    let $termLink = res.data.main_business.settings.reg_conditions;
                    if($termLink){
                        window.open($termLink, '_system');
                    }else{
                        window.open("https://www.appsuitecrm.com/appsuite-terms-use/", '_system');
                    }
                })
            },
            register() {
                
                if(!this.phonePayload.isValid){
                    this.$store.commit("shared/setAlert","Phone number is invalid")
                    return false;
                }
                this.$store.dispatch("user/registerUser", {
                    callback: () => {
                        this.$store.dispatch("user/login", {username: this.form['base-email'], password: this.form.password, callback: this.afterRegistration});
                    }
                })
            },
            afterRegistration() {
                let data = {
                    "email": {
                        "all_emails_disabled": !Boolean(this.form.notifications)
                    }
                };
                axios.put(`/auth/users/${this.user.member_id}/profile/notification_settings`, data)
                this.$router.push({name: "Home"});
                this.$store.commit("user/setRegistredForm", null);
            },
            onUpdatePhone (payload) {
                this.phonePayload = payload;
                if(payload.countryCallingCode){
                    this.form['base-phone_code'] = payload.countryCallingCode;
                }else{
                    this.form.country_code = null;
                }
            }
        },
        computed: {
            form(){
                if(!this.$store.state.user.registredForm){
                    this.$store.state.user.registredForm = {...this.$store.state.user.registredFormDef}
                }
                return this.$store.state.user.registredForm;
            }
        }
    }
</script>
